import { render } from "./TestimonialComponent.vue?vue&type=template&id=4ff22c17"
import script from "./TestimonialComponent.vue?vue&type=script&lang=js"
export * from "./TestimonialComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__